























































































































































































































































































































import { Component } from "vue-property-decorator";
import OperationProperties from "@/components/operations/OperationProperties.vue";
import BackLink from "@/components/app/BackLink.vue";
import VerifyBox from "@/components/app/VerifyBox.vue";
import { CatalogOperationVueGB } from "@/extensions/operations/CatalogOperationVueGB";
import AccountInDefaultModal from "@/components/settings/AccountInDefaultModal.vue";
import OperationModal from "@/components/history/OperationModal.vue";
import SbpEnableModal from "@/components/settings/SbpEnableModal.vue";
import i18n from "@/i18n";
import DetailsList from "@/components/app/DetailsList.vue";
import AcceptProperty from "./propeties/AcceptProperty.vue";
import FsTemplateDialog from "@/components/templates/FsTemplateDialog.vue";

@Component({
  components: { OperationProperties, VerifyBox, BackLink, SbpEnableModal, AccountInDefaultModal, OperationModal, DetailsList, AcceptProperty, FsTemplateDialog }
})
export default class CatalogOperation extends CatalogOperationVueGB {
  fromTemplate: boolean = false;
  templateId: string | null = null;
  sbpOutVisible: boolean = false;

  mounted() {
    // Отображение согласия в операции c2g
    //this.sbpOutVisible = !this.personStore.personInfo.Data.EnableSbpOut;

    if (this.isSBPOperToMySelf && this.personStore.personInfo.Data.DefaultInAccount.length === 0) {
      this.alertService.sbp(i18n.t('main.settings.errors.sbpInAcntinclude').toString(), true);
      this.accntInModalShow = true;
    }    
    if (this.$route.query.fromTemplate === 'true') {
      
      this.fromTemplate = true;
      const templateId = this.$route.params.id;
      const templateIdNumber = Number(templateId);

      const template = this.templatesStore.simpleTemplates.find(t => t.Id === templateIdNumber) ||
                       this.templatesStore.periodTemplates.find(t => t.Id === templateIdNumber);

      if (template) {
        this.selectedTemplate = template;
      }
    }

    document.addEventListener('keydown', this.preventEnterOnForm);
  }

  handleTemplateClose() {
    this.editMode = false;
    this.init();
  }

  preventEnterOnForm(e: any) {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  }
}
